import { KYC_PROVIDER } from '@constants';

// KYC UPDATE STATES HANDLING
export const ALLOWED_STATES_FOR_UPDATE = {
  [KYC_PROVIDER.EFR]: {
    VERIFY: ['DUPLICATE_CHECK'],
    REJECT: ['DUPLICATE_CHECK', 'EFR_VERIFICATION'],
  },
  [KYC_PROVIDER.COMPLY_CUBE]: {
    VERIFY: ['IDENTITY', 'PROOF_OF_IDENTITY', 'DUPLICATE_CHECK'],
    REJECT: ['IDENTITY', 'PROOF_OF_IDENTITY', 'DUPLICATE_CHECK']
  },
  [KYC_PROVIDER.SABER]: {
    VERIFY: ['ON_RAMP_KYC_DATA'],
    REJECT: ['ON_RAMP_KYC_DATA']
  },
  [KYC_PROVIDER.SUMSUB]: {
    UNBLOCK: {
      PROOF_OF_IDENTITY: [
        {
          allowedFromStates: ['BLOCKED'],
          conditions: { rejectionReasons: 'DUPLICATE_USER' }
        }
      ]
    }
  }
};

export const canVerifyDataType = (kycProvider, dataType, kycStatus) => {
  return (
    (kycStatus === 'PENDING_FOR_VERIFICATION' ||
      (kycStatus === 'DRAFT' && dataType === 'DUPLICATE_CHECK')) &&
    ALLOWED_STATES_FOR_UPDATE.hasOwnProperty(kycProvider) &&
    ALLOWED_STATES_FOR_UPDATE[kycProvider].VERIFY !== undefined &&
    ALLOWED_STATES_FOR_UPDATE[kycProvider].VERIFY.includes(dataType)
  );
};

export const canRejectDataType = (kycProvider, dataType, kycStatus) => {
  return (
    (kycStatus === 'PENDING_FOR_VERIFICATION' ||
      (kycStatus === 'DRAFT' && dataType === 'DUPLICATE_CHECK')) &&
    ALLOWED_STATES_FOR_UPDATE.hasOwnProperty(kycProvider) &&
    ALLOWED_STATES_FOR_UPDATE[kycProvider].REJECT !== undefined &&
    ALLOWED_STATES_FOR_UPDATE[kycProvider].REJECT.includes(dataType)
  );
};

export const canUnblockDataType = (kycProvider, dataType, kycStatus, extra = {}) => {
  if (
    !ALLOWED_STATES_FOR_UPDATE.hasOwnProperty(kycProvider) ||
    !ALLOWED_STATES_FOR_UPDATE[kycProvider].UNBLOCK ||
    !ALLOWED_STATES_FOR_UPDATE[kycProvider].UNBLOCK.hasOwnProperty(dataType)
  ) {
    return false;
  }

  return ALLOWED_STATES_FOR_UPDATE[kycProvider].UNBLOCK[dataType].some(rule => {
    const matchesState = rule.allowedFromStates
      ? rule.allowedFromStates.includes(kycStatus)
      : true;
    const matchesConditions = rule.conditions
      ? Object.entries(rule.conditions).every(
          ([key, value]) => {
            if (Array.isArray(extra[key])) {
              return extra[key].includes(value);
            }
            return extra[key] === value;
          }
        )
      : true;
    return matchesState && matchesConditions;
  });
};

// SYNC STATES HANDLING
const allowedProvidersForSync = [
  KYC_PROVIDER.EFR,
  KYC_PROVIDER.SABER,
  KYC_PROVIDER.COMPLY_CUBE,
  KYC_PROVIDER.SUMSUB,
  KYC_PROVIDER.VANCE,
  KYC_PROVIDER.PERSONA
];

export const isAllowedKycProviderForSync = (provider) =>
  allowedProvidersForSync.includes(provider);

// DASHBOARD UI HANDLING

const providerDashboardConfig = {
  [KYC_PROVIDER.COMPLY_CUBE]: {
    text: 'Comply Cube Dashboard',
    url: 'https://portal.complycube.com/clients/{clientId}#tab-checks'
  },
  [KYC_PROVIDER.SUMSUB]: {
    text: 'Sumsub Dashboard',
    url: 'https://cockpit.sumsub.com/checkus/#/applicant/{clientId}/basicInfo?clientId=vance.tech_45146'
  },
  [KYC_PROVIDER.PERSONA]: {
    text: 'Persona Dashboard',
    url: 'https://app.withpersona.com/dashboard/accounts/{clientId}'
  }
};

export const getProviderDashboardConfigOrNull = (kycProvider) => {
  if (providerDashboardConfig[kycProvider] === undefined) {
    return null;
  }
  return providerDashboardConfig[kycProvider];
};

export const getUserKycStatusDetailsTable = (userKycStatusDetails, provider) => {
  if (!userKycStatusDetails) {
    return null;
  }
  if (provider === KYC_PROVIDER.SUMSUB) {
    return [
      {
        title: 'Linked Duplicate Accounts',
        data: [
          {
            name: 'UserId',
            isCopyable: true,
            value: userKycStatusDetails.userId || '-'
          }
        ],
        tableData:
          (Array.isArray(userKycStatusDetails?.userKycStatuses) ? userKycStatusDetails.userKycStatuses : []).map((item) => ({
            userId: item.userId || '-',
            kycStatus: item.status || '-'
          }))
      }
    ];
  }

  return [
    {
      title: 'Linked Duplicate Accounts',
      data: [
        {
          name: 'Emirates Id ',
          isCopyable: true,
          value: userKycStatusDetails.emiratesId || '-'
        },
        {
          name: 'Phone ',
          isCopyable: true,
          value: userKycStatusDetails.phone || '-'
        }
      ],
      tableData:
        userKycStatusDetails?.userKycStatus?.map((item) => ({
          userId: item.userId || '-',
          kycStatus: item.kycStatus || '-'
        })) || []
    }
  ];
};
